import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Filter known harmless dev-only warnings to keep the console clean:
// 1. Recharts ResponsiveContainer 'width(-1) height(-1)' first-paint noise
// 2. Radix DialogContent missing aria-describedby (we use sr-only descriptions)
const _origWarn = console.warn;
console.warn = function (...args) {
  const msg = typeof args[0] === "string" ? args[0] : "";
  if (msg.includes("width(-1) and height(-1) of chart")) return;
  if (msg.includes("Missing `Description` or `aria-describedby")) return;
  _origWarn.apply(console, args);
};

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
